package de.connect2x.timmy.brandings.lifetimeTheme

import androidx.compose.ui.graphics.Color

internal val lt_blue = Color(0xFF087FB9)
internal val lt_dark_blue = Color(0xFF1F4050)
internal val lt_light_blue = Color(0xFFC4E9FF)
internal val lt_light_gray = Color(0xFFDBEDF7)
internal val lt_medium_gray = Color(0xFF64747C)
internal val lt_dark_gray = Color(0xFF3F4C54)

internal val lt_accent_cyan = Color(0xFF7EEEEB)
internal val lt_accent_blue = Color(0xFFA6E0FF)
internal val lt_accent_red = Color(0xFFFF8888)
internal val lt_accent_orange = Color(0xFFFFD5BD)

